package com.upcominds.expedite.data.mobilelogs

data class AppRuntimeInfo(
    val platform: String,
    val appVersion: String? = null,
    val buildNumber: String? = null,
    val osVersion: String? = null,
    val loggingEnabled: Boolean
)

expect object AppRuntimeInfoProvider {
    fun current(): AppRuntimeInfo
}
